module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section04_03_american-village-572d5181866f3a994e561c1dc47b3d7d.jpg";